import { ReactComponent as SuccessIcon } from './success.svg';

export default SuccessIcon;
